module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/our_services_1-ed4ce278c6a3282a783fb985eef59089.jpg";